import React, { useCallback } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import CecoLogo from 'assets/png/cecotec-blue.png';
import { CecoMenu, CecoSignOut } from 'assets/icons';
import getMenuItems from './getMenuItems';
import classnames from 'classnames';
import useWindowDimensions from 'hooks/useWindowDimensions';
import { logout } from 'services/auth.service';
import { version } from '../../../package.json';
import userImage from 'assets/png/user-default-grey.png';
import { useApp } from 'context/AppProvider';
import { Icon, Label } from 'semantic-ui-react';
import cleanLocalStorage from 'modules/clean-local-storage/clean-local-storage';
import EfficiencyKPI from 'components/EfficiencyKPI/EfficiencyKPI';
import Portal from 'components/Portal/Portal';
import { useDispatch } from 'react-redux';
import { emptyStore } from 'redux/actions/feed-store-actions';
import { useUser } from 'hooks/redux/useUser';
import './MenuLeft.scss';

function MenuLeft(props) {
  const { menuIsOpen, setMenuIsOpen } = useApp();
  const dispatch = useDispatch();

  const onLogoutClick = useCallback(async () => {
    try {
      await logout();
      cleanLocalStorage();
      dispatch(emptyStore());
      props.history.push('/login');
    } catch (error) {
      console.error(error);
    }
  }, [props.history, dispatch]);

  return (
    <div
      className={classnames('menu-left', {
        open: menuIsOpen,
        close: !menuIsOpen,
      })}
    >
      <div className="menu-left__header">
        <div className="menu-left__header-logo">
          {menuIsOpen && (
            <div className="logo_wrapper">
              <img src={CecoLogo} alt="Cecotec" />
              <span>v{version}</span>
            </div>
          )}
          <CecoMenu onClick={() => setMenuIsOpen(!menuIsOpen)} />
        </div>
      </div>
      <div className="menu-left__body">
        <div className="menu-items">
          {getMenuItems().map((menu, index) => (
            <RenderMenu
              key={index}
              visible={menuIsOpen}
              menu={menu}
              menuIsOpen={menuIsOpen}
              setIsOpenMenu={setMenuIsOpen}
            />
          ))}
        </div>
        <div className="efficiency">
          <EfficiencyKPI />
          <Portal.Out name="menu-left-widgets" />
        </div>
      </div>
      <div className="menu-left__footer">
        <MenuUser menuIsOpen={menuIsOpen} onLogoutClick={onLogoutClick} />
      </div>
    </div>
  );
}

function RenderMenu(props) {
  const { menu, menuIsOpen, setIsOpenMenu } = props;
  const { name, icon: IconMenu, path } = menu;
  const { windowWidth } = useWindowDimensions();

  const closeMenu = () => {
    if (windowWidth < 768.99) {
      window.setTimeout(() => {
        setIsOpenMenu(!menuIsOpen);
      }, 300);
    }
  };

  return (
    <NavLink
      to={path}
      activeClassName="active"
      className="item"
      onClick={closeMenu}
    >
      <IconMenu />
      <span
        className={classnames({
          hidden: menuIsOpen,
        })}
      >
        {name}
      </span>
    </NavLink>
  );
}

function MenuUser(props) {
  const { menuIsOpen, onLogoutClick } = props;
  const { user, permissions } = useUser();

  return (
    <div
      className="menu-left__footer-user"
      style={!menuIsOpen ? { justifyContent: 'center' } : null}
    >
      <div>
        <img src={userImage} width={35} alt="" />
        {menuIsOpen && (
          <div>
            <div className="menu-left__footer-user-email">
              {!!permissions?.length ? (
                user?.email
              ) : (
                <>
                  <Icon loading name="sync" size="large" /> Cargando…
                </>
              )}
            </div>
            {!!user?.group && (
              <Label size="mini" color="teal" className="menu-left__role-label">
                {user.group}
              </Label>
            )}{' '}
            {!!user?.warehouse?.warehouse && (
              <Label size="mini" color="olive">
                {user.warehouse.warehouse}
              </Label>
            )}
          </div>
        )}
      </div>
      <CecoSignOut onClick={onLogoutClick} />
    </div>
  );
}

export default withRouter(MenuLeft);
